/* Kaddanse — animations « façade » (deck façade 16.08).
   Pour l'instant : l'onde des titres (.bf-h__rule) joue sa montée une seule
   fois quand elle entre à l'écran. Sans JS ni IntersectionObserver : l'onde
   est visible d'emblée, rien ne casse. Fichier assets — jamais inline. */
(function () {
  function init() {
    if (!('IntersectionObserver' in window)) return;
    // L'onde des titres joue sa montée…
    var ondes = document.querySelectorAll('.bf-h__rule:not([data-kdd-onde])');
    if (ondes.length) {
      var obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('bf-h__rule--joue');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.6 });
      ondes.forEach(function (o) {
        o.setAttribute('data-kdd-onde', '1');
        obs.observe(o);
      });
    }
    // …et tout élément [data-kdd-apparition] reçoit .kdd-apparu à l'entrée
    // dans le viewport (une fois) — les jauges du banc d'essai s'en servent.
    var blocs = document.querySelectorAll('[data-kdd-apparition]:not([data-kdd-apparition-vu])');
    if (blocs.length) {
      var obs2 = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('kdd-apparu');
            obs2.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      blocs.forEach(function (b) {
        b.setAttribute('data-kdd-apparition-vu', '1');
        obs2.observe(b);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
